import { getMenuOptions } from "../../App.helper";

import Menubar from "../../components/menu-bar/Menubar";
import Folder from "../../components/folder/Folder";
import TrackDisplay from "../../components/track-display/TrackDisplay";
import Calendar from "../../components/calendar/Calendar";
import Widget from "../../components/widget/Widget";

import yellow3 from "../../assets/yellow3_bg.jpg";

import "./HomePage.css";
import { Checkbox, Col, Flex, Row, Tooltip } from "antd";
import { FOLDERS } from "../../data/folder";
import { APP_INFO } from "../../data/app";
import { useEffect, useState } from "react";
import { PLAYLIST } from "../../data/music";

// Standalone Image Component
const DashboardImage = ({ src, alt, colSpan = 1, rowSpan = 1, style }) => {
  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: "100%",
        borderRadius: 12,
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        objectFit: "cover",
        gridColumn: `span ${colSpan}`,
        gridRow: `span ${rowSpan}`,
        ...style,
      }}
    />
  );
};

const ChecklistItem = ({ label, checked = false }) => {
  const [visible, setVisible] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setVisible(true);
    setTimeout(() => setVisible(false), 1500);
  };

  return (
    <Tooltip
      title={checked ? "Oh I'm so done" : "Working on it!"}
      visible={visible}
      trigger="click"
      placement="topLeft"
    >
      <Checkbox
        style={{ cursor: 'pointer' }}
        checked={checked}
        onChange={handleClick}>
        {label}
      </Checkbox>
    </Tooltip>
  );
};

const openCalendarTooltip = () => {
  <Tooltip title="It's just pretty. Shoot me an email instead!"
    visible={true}
    trigger="click"
    placement="topLeft"
  >
    <span></span>
  </Tooltip>
}

const HomePage = () => {
  const menuOptions = getMenuOptions();

  const [now, setNow] = useState(new Date());

  const [activeSong, setActiveSong] = useState(0);

  const handleNextSong = () => {
    if (activeSong < PLAYLIST.length - 1) {
      setActiveSong(activeSong + 1);
    } else {
      setActiveSong(0);
    }
  }

  const handlePrevSong = () => {
    if (activeSong > 0) {
      setActiveSong(activeSong - 1);
    } else {
      setActiveSong(PLAYLIST.length - 1);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 60_000);

    return () => clearInterval(interval);
  }, []);


  return (
    <div className="home-root">
      <Menubar options={menuOptions} />
      {/* PLAYING SONG */}
      <div className="playing-song">
        <TrackDisplay
          trackName={PLAYLIST[activeSong].title}
          artistName={PLAYLIST[activeSong].artist}
          handleNext={handleNextSong}
          handlePrev={handlePrevSong} />
      </div>

      <Row gutter={24} className="dashboard-row">
        {/* LEFT */}
        <Col xs={24} md={12} lg={8} className="dashboard-col">
          <Flex vertical gap={16}>
            <Widget className="time">
              <h2>
                {now.toLocaleDateString("en-US", {
                  weekday: "long",
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })}
              </h2>

              <h4>
                {now.toLocaleString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })}
              </h4>
            </Widget>

            <Widget className="folder-grid">
              {FOLDERS.map((f) => (
                <Folder key={f.key} title={f.title}
                  items={APP_INFO.filter(app => app.category === f.key)
                  } />
              ))}
            </Widget>

            <Widget className="quote">
              <p>“When there’s a will, there’s a way.”</p>
            </Widget>
          </Flex>
        </Col>

        {/* MIDDLE */}
        <Col xs={24} md={12} lg={8} className="dashboard-col">
          <div className="calendar-container">
            <Calendar onDateClick={openCalendarTooltip} />
          </div>
        </Col>

        {/* RIGHT */}
        <Col xs={24} md={24} lg={8}>
          <Flex vertical gap={16}>
            <DashboardImage src={yellow3} alt="yellow-bg-image" />

            <Widget>
              <h4>Checklist</h4>
              <ChecklistItem label="Web Portfolio Up" checked />
              <ChecklistItem label="Two Additional Folders *hehe*" />
              <ChecklistItem label="Phone Layout" checked />
            </Widget>
          </Flex>
        </Col>
      </Row>
    </div>
  );
};

export default HomePage;
